import React from "react";
import hearderbg from "../Assest/new_logo_withshreebalaji.png";

export default function Terms() {
  return (
    <div className="text-gray-800 overflow-hidden">

      {/* HERO */}
      <section
        className="relative py-28 bg-cover bg-center"
        style={{ backgroundImage: `url(${hearderbg})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#2C3E5C]/70 via-[#1F2A44]/60 to-[#000]/50"></div>

        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center text-white">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Terms & Conditions
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-white/90">
            Please read these terms carefully before using our services.
          </p>
        </div>
      </section>

      {/* TERMS CONTENT */}
      <section className="py-20 bg-gradient-to-b from-slate-50 to-white">
        <div className="max-w-5xl mx-auto px-6 space-y-12 text-gray-700 leading-relaxed">

          {/* INTRODUCTION */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Introduction</h2>
            <p>
              Welcome to <strong>ShreeBalajee Connect Pvt. Ltd. (BINGOPAY)</strong>
              ("Company", "we", "us", or "our"). These Terms and Conditions
              govern your access to and use of our website, applications,
              and services (“Services”).
            </p>
            <p className="mt-3">
              By accessing or using our Services, you agree to be legally bound
              by these Terms, our Privacy Policy, and other applicable policies.
              If you do not agree, you must discontinue use immediately.
            </p>
          </div>

          {/* DEFINITIONS */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Definitions</h2>
            <ul className="list-disc list-inside space-y-2">
              <li><strong>User:</strong> Any individual or entity accessing our Services.</li>
              <li><strong>Content:</strong> All materials including text, graphics, logos, software, etc.</li>
              <li><strong>Personal Data:</strong> Any data identifying an individual.</li>
              <li><strong>Services:</strong> All features and solutions offered by the Company.</li>
              <li><strong>Third-Party Services:</strong> External services integrated into our platform.</li>
              <li><strong>Agreement:</strong> These Terms and related policies.</li>
            </ul>
          </div>

          {/* ACCEPTANCE */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Acceptance of Terms</h2>
            <p>
              By using our Services, you confirm that you have read, understood,
              and agreed to these Terms. Continued use constitutes acceptance of
              any future updates.
            </p>
          </div>

          {/* ELIGIBILITY */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Eligibility</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>You must be at least 18 years old.</li>
              <li>You must have legal capacity to enter into agreements.</li>
              <li>You must comply with all applicable laws and regulations.</li>
              <li>Previously suspended users may not re-register.</li>
            </ul>
          </div>

          {/* USER OBLIGATIONS */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">User Obligations</h2>
            <ul className="list-disc list-inside space-y-2">
              <li>Provide accurate and updated information.</li>
              <li>Maintain account security.</li>
              <li>Avoid fraudulent or illegal activities.</li>
              <li>Do not distribute malware or harmful software.</li>
              <li>Do not misuse intellectual property.</li>
            </ul>
          </div>

          {/* INTELLECTUAL PROPERTY */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Intellectual Property</h2>
            <p>
              All content, trademarks, logos, and software are owned by or licensed to
              <strong> ShreeBalajee Connect Pvt. Ltd. (BINGOPAY)</strong> and protected under applicable intellectual property laws.
              Unauthorized reproduction or commercial use is strictly prohibited.
            </p>
          </div>

          {/* DATA PROTECTION */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Data Protection & Privacy</h2>
            <p>
              We comply with applicable data protection laws including the Digital
              Personal Data Protection Act, 2023 (DPDPA). Please refer to our Privacy
              Policy for detailed information.
            </p>
          </div>

          {/* FEES */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Fees & Payments</h2>
            <p>
              Certain Services may require payment. Fees are generally non-refundable
              unless explicitly stated. Users are responsible for applicable taxes.
            </p>
          </div>

          {/* DISCLAIMERS */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Disclaimers</h2>
            <p>
              Services are provided “as-is” and “as-available.” We do not guarantee
              uninterrupted access and are not liable for indirect or consequential damages.
            </p>
          </div>

          {/* INDEMNIFICATION */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Indemnification</h2>
            <p>
              You agree to indemnify and hold harmless the Company from claims arising
              out of misuse of Services or violation of these Terms.
            </p>
          </div>

          {/* TERMINATION */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Termination</h2>
            <p>
              We may suspend or terminate access if you violate these Terms or applicable laws.
              Upon termination, your access rights cease immediately.
            </p>
          </div>

          {/* GOVERNING LAW */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Governing Law & Dispute Resolution</h2>
            <p>
              These Terms are governed by the laws of India. Disputes shall be resolved
              through arbitration under the Arbitration and Conciliation Act, 1996.
              The seat of arbitration shall be Haryana, India.
            </p>
          </div>

          {/* FORCE MAJEURE */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Force Majeure</h2>
            <p>
              The Company shall not be liable for delays or failures caused by events
              beyond reasonable control including natural disasters, government actions,
              cyber-attacks, or pandemics.
            </p>
          </div>

          {/* NOTICES */}
          <div>
            <h2 className="text-2xl font-bold text-indigo-600 mb-4">Notices & Contact</h2>
            <p>Official communications should be sent to:</p>
            <ul className="list-disc list-inside mt-3 space-y-2">
              <li>Email: support@bingopays.in</li>
              <li>Phone: +91 8586 036 036</li>
              <li>Address: #879/13, Kurukshetra, Haryana – 136118, India</li>
            </ul>
          </div>

        </div>
      </section>
    </div>
  );
}
